// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__243mV","title":"AfterFrontImage_title__3OljJ"};